import {HeaderFooterPositions, Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";
import {HeaderFooterOptions} from "./HeaderFooterOptions";

export class PortalHeaderFooterPositions extends HeaderFooterPositions implements Parameter {
	public centerOptions?: HeaderFooterOptions;
	public leftOptions?: HeaderFooterOptions;
	public rightOptions?: HeaderFooterOptions;

	constructor(data: any) {
		super(data);

		this.centerOptions = HeaderFooterOptions.fromJson(data.centerOptions);
		this.leftOptions = HeaderFooterOptions.fromJson(data.leftOptions);
		this.rightOptions = HeaderFooterOptions.fromJson(data.rightOptions);
	}

	public static fromJson(data: any): PortalHeaderFooterPositions {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalHeaderFooterPositions(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'centerOptions': this.centerOptions?.toJson(),
			'leftOptions': this.leftOptions?.toJson(),
			'rightOptions': this.rightOptions?.toJson()
		};
	}

	public clone(): PortalHeaderFooterPositions {
		return PortalHeaderFooterPositions.fromJson(this.toJson());
	}
}